import React from 'react';
import useMap from '../useMap';
import { MapProvider as RawMapProvider } from '../MapContext';
const DEFAULT_ZOOM = 18;
const MapContext = React.createContext({
    loaded: false,
    center: undefined,
    setCenter: undefined,
    bounds: undefined,
    setBounds: undefined,
    map: undefined,
    setMap: undefined,
    mapTypeId: undefined,
    setMapTypeId: undefined,
    zoom: undefined,
    setZoom: undefined,
});
function Inner({ children }) {
    const { center, setCenter } = useMap();
    const [loaded, setLoaded] = React.useState(false);
    const [bounds, setBounds] = React.useState();
    const [zoom, setZoom] = React.useState(DEFAULT_ZOOM);
    const [map, setMap] = React.useState();
    const [mapTypeId, setMapTypeId] = React.useState();
    const provided = { loaded, center, setCenter, bounds, setBounds, map, setMap, mapTypeId, setMapTypeId, zoom, setZoom };
    React.useEffect(() => setLoaded(!!map), [map]);
    React.useEffect(() => {
        if (!loaded || !center || !map) {
            return;
        }
        const tmp = map.getCenter();
        const hasCenter = typeof center.lat === 'number' &&
            typeof center.lng === 'number' &&
            Number.isFinite(center.lat) &&
            Number.isFinite(center.lng);
        if (hasCenter && (!tmp || center.lat !== tmp.lat() || center.lng !== tmp.lng())) {
            map?.setCenter(center);
        }
    }, [loaded, center, map]);
    React.useEffect(() => {
        if (!loaded || !map || (bounds?.length || 0) < 1) {
            return;
        }
        const box = new google.maps.LatLngBounds();
        bounds?.filter((e) => !!e?.lat && !!e?.lng).forEach((e) => box.extend(e));
        map?.fitBounds(box);
    }, [loaded, bounds, map]);
    React.useEffect(() => {
        if (!loaded || !mapTypeId || !map) {
            return;
        }
        map?.setMapTypeId(mapTypeId);
    }, [loaded, mapTypeId, map]);
    React.useEffect(() => {
        if (loaded && zoom && zoom != map?.getZoom()) {
            map?.setZoom(zoom);
        }
    }, [loaded, zoom, map]);
    return React.createElement(MapContext.Provider, { value: provided }, children);
}
function MapProvider({ children }) {
    return (React.createElement(RawMapProvider, null,
        React.createElement(Inner, null, children)));
}
export { MapContext, MapProvider };
